/* tslint:disable */

/**
 * The vehicle type:
 *   * LIGHT:
 *   * LDV:
 *   * HEAVY:
 *   * HEAVY_WITH_TRAILER:
 *   * BIKE:
 *   * MOTORBIKE:
 *   * GARBAGE_TRUCK:
 *   * BUS:
 *   * UNDEFINED
 */
type VehicleType =
  'LIGHT' |
  'LDV' |
  'HEAVY' |
  'HEAVY_WITH_TRAILER' |
  'BIKE' |
  'MOTORBIKE' |
  'GARBAGE_TRUCK' |
  'BUS' |
  'UNDEFINED';
module VehicleType {
  export const LIGHT: VehicleType = 'LIGHT';
  export const LDV: VehicleType = 'LDV';
  export const HEAVY: VehicleType = 'HEAVY';
  export const HEAVY_WITH_TRAILER: VehicleType = 'HEAVY_WITH_TRAILER';
  export const BIKE: VehicleType = 'BIKE';
  export const MOTORBIKE: VehicleType = 'MOTORBIKE';
  export const GARBAGE_TRUCK: VehicleType = 'GARBAGE_TRUCK';
  export const BUS: VehicleType = 'BUS';
  export const UNDEFINED: VehicleType = 'UNDEFINED';
  export function values(): VehicleType[] {
    return [
      LIGHT,
      LDV,
      HEAVY,
      HEAVY_WITH_TRAILER,
      BIKE,
      MOTORBIKE,
      GARBAGE_TRUCK,
      BUS,
      UNDEFINED
    ];
  }
}

export { VehicleType }